import { Component, input } from '@angular/core'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { ViewUI } from '@app/feature/header/workspace-controls/advanced-options/view-section/view-section.component'
import { TranslocoDirective } from '@jsverse/transloco'

@Component({
    selector: 'app-view-section-content',
    imports: [TbIconComponent, TranslocoDirective],
    templateUrl: './view-section-content.component.html',
})
export class ViewSectionContentComponent {
    views = input.required<ViewUI[]>()
}
